//Post Metadata Extractor
export const POST_METADATAEXTRACTOR_REQUEST = "POST_METADATAEXTRACTOR_REQUEST";
export const POST_METADATAEXTRACTOR_SUCCESS = "POST_METADATAEXTRACTOR_SUCCESS";
export const POST_METADATAEXTRACTOR_FAILURE = "POST_METADATAEXTRACTOR_FAILURE";

//Put Metadata Extractor
export const PUT_METADATAEXTRACTOR_REQUEST = "PUT_METADATAEXTRACTOR_REQUEST";
export const PUT_METADATAEXTRACTOR_SUCCESS = "PUT_METADATAEXTRACTOR_SUCCESS";
export const PUT_METADATAEXTRACTOR_FAILURE = "PUT_METADATAEXTRACTOR_FAILURE";

//Get Extractor table metadata
export const FETCH_EXTTABLEMETADATA_REQUEST = "FETCH_EXTTABLEMETADATA_REQUEST";
export const FETCH_EXTTABLEMETADATA_SUCCESS = "FETCH_EXTTABLEMETADATA_SUCCESS";
export const FETCH_EXTTABLEMETADATA_FAILURE = "FETCH_EXTTABLEMETADATA_FAILURE";

//Get Foundry Extractor table metadata
export const FETCH_FOUNDRYTABLEMETADATA_REQUEST = "FETCH_FOUNDRYTABLEMETADATA_REQUEST";
export const FETCH_FOUNDRYTABLEMETADATA_SUCCESS = "FETCH_FOUNDRYTABLEMETADATA_SUCCESS";
export const FETCH_FOUNDRYTABLEMETADATA_FAILURE = "FETCH_FOUNDRYTABLEMETADATA_FAILURE";